import { Pane, Text, Badge, Tooltip } from 'evergreen-ui';
import useWindowSize from '../../../utils/useWindowSize';

export default function VistaMensile({
  mockDays,
  showOnlyUncovered,
  turniData,
  managerFerieList,
  isDirector,
  getInitials,
  getBadgeProps,
  handleDrop,
  handleDayClick,
  setShiftInputs,
  shiftInputs,
  setIsTurnoModalOpen,
  onShiftDragStart,
}) {
  const isMobile = useWindowSize() < 768;
  const giorniSettimana = ['LUN', 'MAR', 'MER', 'GIO', 'VEN', 'SAB', 'DOM'];

  if (isMobile) {
    return (
      <Pane display="flex" flexDirection="column" gap={12}>
        {mockDays.map((day, dIdx) => {
          if (!day) return null;

          if (showOnlyUncovered && day.status === 'coperto') {
            return (
              <Pane key={`hidden_${day.date}`} border="none" padding={12} background="tint1" borderRadius={8} opacity={0.5} display="flex" justifyContent="space-between" alignItems="center">
                <Pane display="flex" alignItems="baseline" gap={8}>
                  <Text size={500} fontWeight="bold">{day.date}</Text>
                  <Text size={300}>{giorniSettimana[dIdx % 7]}</Text>
                </Pane>
                <Text size={300} color="muted" fontWeight="bold">COPERTO</Text>
              </Pane>
            );
          }

          const dayShifts = turniData.filter((t) => t.date === day.fullDate);
          const leaves = managerFerieList.filter(l => l.start_date <= day.fullDate && l.end_date >= day.fullDate && l.status === 'approvata');

          return (
            <Pane
              key={day.date}
              border="default"
              borderRadius={8}
              padding={16}
              background={day.fullDate === new Date().toISOString().split('T')[0] ? 'tint1' : 'white'}
              onClick={() => handleDayClick(day)}
              cursor="pointer"
              display="flex"
              flexDirection="column"
              gap={12}
            >
              <Pane display="flex" justifyContent="space-between" alignItems="center" borderBottom="muted" paddingBottom={8}>
                <Pane display="flex" alignItems="baseline" gap={8}>
                  <Text size={500} fontWeight="bold">{day.date}</Text>
                  <Text size={300}>{giorniSettimana[dIdx % 7]}</Text>
                </Pane>
              </Pane>

              <Pane display="flex" flexWrap="wrap" gap={8}>
                {leaves.map((l, idx) => {
                  if (dayShifts.some(s => s.operator_name === l.operator_name && ['ferie', 'permesso', 'malattia'].includes(s.shift_type))) {
                    return null;
                  }
                  const leaveInitial = (l.leave_type || 'FER').substring(0,1).toUpperCase();
                  const leaveText = isDirector ? `${leaveInitial} - ${getInitials(l.operator_name)}` : `ASS - ${getInitials(l.operator_name)}`;
                  const leaveColor = isDirector ? (leaveInitial === 'M' ? 'red' : leaveInitial === 'P' ? 'yellow' : 'green') : 'neutral';
                  return (
                    <Tooltip content={isDirector ? (l.motivazione || 'Assenza') : 'Assenza'} key={`l_${idx}`}>
                      <Badge color={leaveColor} isSolid paddingX={8} paddingY={4} style={{ whiteSpace: 'normal', height: 'auto', lineHeight: '1.5' }}>
                        {leaveText}
                      </Badge>
                    </Tooltip>
                  );
                })}
                {dayShifts.map((s, idx) => {
                  const bp = getBadgeProps(s.shift_type);
                  const isAbsence = ['ferie', 'permesso', 'malattia'].includes(s.shift_type);
                  const badgeColor = (!isDirector && isAbsence) ? 'neutral' : bp.color;
                  
                  let badgeText = '';
                  if (!isDirector && isAbsence) {
                    badgeText = `ASS - ${getInitials(s.operator_name)}`;
                  } else if (isAbsence) {
                    let timeStr = "";
                    if (['permesso', 'ferie'].includes(s.shift_type) && s.start_time && s.start_time.substring(0,5) !== '00:00' && s.end_time) {
                      timeStr = ` ${s.start_time.substring(0,5)}-${s.end_time.substring(0,5)}`;
                    }
                    badgeText = `${bp.text}${timeStr} - ${getInitials(s.operator_name)}`;
                  } else {
                    badgeText = `${s.start_time?.substring(0,5) || '?'} / ${s.end_time?.substring(0,5) || '?'} - ${getInitials(s.operator_name)}`;
                  }

                  const noteText = (s.notes && String(s.notes).trim() !== '' && String(s.notes) !== '0') ? s.notes : 'Nessuna nota';

                  return (
                    <Tooltip content={isDirector ? noteText : (isAbsence ? 'Assenza' : noteText)} key={`s_${idx}`}>
                      <Badge color={badgeColor} isSolid paddingX={8} paddingY={4} style={{ whiteSpace: 'normal', height: 'auto', lineHeight: '1.5', cursor: isDirector && !isAbsence ? 'grab' : 'default' }} draggable={isDirector && !isAbsence} onDragStart={(e) => { e.stopPropagation(); if (isDirector && !isAbsence) onShiftDragStart(e, s.id); }} onClick={(e) => { e.stopPropagation(); if (isDirector) { setShiftInputs({...shiftInputs, date: day.fullDate, operator_name: s.operator_name, start_time: s.start_time || '', end_time: s.end_time || '', shift_type: s.shift_type}); setIsTurnoModalOpen(true); } }}>
                        {badgeText}
                      </Badge>
                    </Tooltip>
                  )
                })}
                {leaves.length === 0 && dayShifts.length === 0 && (
                  <Text size={300} color="muted">Nessun turno assegnato</Text>
                )}
              </Pane>
            </Pane>
          )
        })}
      </Pane>
    );
  }

  return (
    <Pane display="grid" gridTemplateColumns="repeat(7, minmax(90px, 1fr))" gap={8}>
      {giorniSettimana.map(g => (
        <Pane key={g} textAlign="center" paddingY={8} background="tint2" borderRadius={4}>
          <Text fontWeight="bold">{g}</Text>
        </Pane>
      ))}
      {mockDays.map((day, dIdx) => {
        if (!day) return <Pane key={`empty_${dIdx}`} background="tint1" border="none" minHeight={100} />;
        if (showOnlyUncovered && day.status === 'coperto') {
          return (
            <Pane key={`hidden_${day.date}`} border="none" padding={8} background="tint1" borderRadius={4} opacity={0.5} minHeight={100} display="flex" alignItems="center" justifyContent="center">
              <Text size={300} color="muted" fontWeight="bold">Giornata coperta</Text>
            </Pane>
          );
        }

        const dayShifts = turniData.filter((t) => t.date === day.fullDate);
        const leaves = managerFerieList.filter(l => l.start_date <= day.fullDate && l.end_date >= day.fullDate && l.status === 'approvata');
        
        return (
          <Pane
            key={day.date}
            minHeight={100}
            border="default"
            padding={8}
            background={day.fullDate === new Date().toISOString().split('T')[0] ? 'tint1' : 'white'}
            onDragOver={e => e.preventDefault()}
            onDrop={e => handleDrop(e, day.fullDate)}
            onClick={() => handleDayClick(day)}
            cursor="pointer"
            hoverElevation={2}
          >
            <Text size={300} fontWeight="bold">{day.date}</Text>
            <Pane marginTop={8} display="flex" flexDirection="column" gap={4}>
              {leaves.map((l, idx) => {
                // Evita duplicati se c'è già il turno
                if (dayShifts.some(s => s.operator_name === l.operator_name && ['ferie', 'permesso', 'malattia'].includes(s.shift_type))) {
                  return null;
                }
                const leaveInitial = (l.leave_type || 'FER').substring(0,1).toUpperCase();
                let timeStr = "";
                if (['permesso', 'ferie'].includes(l.leave_type) && l.start_time && l.start_time.substring(0,5) !== '00:00' && l.end_time) {
                  timeStr = ` ${l.start_time.substring(0,5)}-${l.end_time.substring(0,5)}`;
                }
                const leaveText = isDirector ? `${leaveInitial}${timeStr} - ${getInitials(l.operator_name)}` : `ASS - ${getInitials(l.operator_name)}`;
                const leaveColor = isDirector ? (leaveInitial === 'M' ? 'red' : leaveInitial === 'P' ? 'yellow' : 'green') : 'neutral';
                return (
                  <Tooltip content={isDirector ? (l.motivazione || 'Assenza') : 'Assenza'} key={`l_${idx}`}>
                            <Badge color={leaveColor} isSolid style={{ whiteSpace: 'normal', height: 'auto', lineHeight: '1.5', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {leaveText}
                            </Badge>
                  </Tooltip>
                );
              })}
              {dayShifts.map((s, idx) => {
                const bp = getBadgeProps(s.shift_type);
                const isAbsence = ['ferie', 'permesso', 'malattia'].includes(s.shift_type);
                const badgeColor = (!isDirector && isAbsence) ? 'neutral' : bp.color;
                
                let badgeText = '';
                if (!isDirector && isAbsence) {
                  badgeText = `ASS - ${getInitials(s.operator_name)}`;
                } else if (isAbsence) {
                  let timeStr = "";
                  if (['permesso', 'ferie'].includes(s.shift_type) && s.start_time && s.start_time.substring(0,5) !== '00:00' && s.end_time) {
                    timeStr = ` ${s.start_time.substring(0,5)}-${s.end_time.substring(0,5)}`;
                  }
                  badgeText = `${bp.text}${timeStr} - ${getInitials(s.operator_name)}`;
                } else {
                  badgeText = `${s.start_time?.substring(0,5) || '?'} / ${s.end_time?.substring(0,5) || '?'} - ${getInitials(s.operator_name)}`;
                }

                const noteText = (s.notes && String(s.notes).trim() !== '' && String(s.notes) !== '0') ? s.notes : 'Nessuna nota';

                return (
                  <Tooltip content={isDirector ? noteText : (isAbsence ? 'Assenza' : noteText)} key={`s_${idx}`}>
                            <Badge color={badgeColor} isSolid style={{ whiteSpace: 'normal', height: 'auto', lineHeight: '1.5', overflow: 'hidden', textOverflow: 'ellipsis', cursor: isDirector && !isAbsence ? 'grab' : 'default' }} draggable={isDirector && !isAbsence} onDragStart={(e) => { e.stopPropagation(); if (isDirector && !isAbsence) onShiftDragStart(e, s.id); }} onClick={(e) => { e.stopPropagation(); if (isDirector) { setShiftInputs({...shiftInputs, date: day.fullDate, operator_name: s.operator_name, start_time: s.start_time || '', end_time: s.end_time || '', shift_type: s.shift_type}); setIsTurnoModalOpen(true); } }}>
                              {badgeText}
                            </Badge>
                  </Tooltip>
                )
              })}
            </Pane>
          </Pane>
        )
      })}
    </Pane>
  );
}
